<script lang="ts">
import { defineComponent, PropType, ref, computed, watch, onMounted } from 'vue'
import InputFormMailAddress from '@/components/lead/InputFormMailAddress.vue'
import { formDefaultProps } from '@/models/formPartial'
import { useUserStore } from '@/stores/user'

export default defineComponent({
  name: 'InputFormWorkMailAddress',

  components: {
    InputFormMailAddress,
  },

  props: {
    ...formDefaultProps,

    modelValue: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    /**
     * autocomplete 属性に渡す値
     * @see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/autocomplete
     */
    autocomplete: {
      type: String as PropType<AutocompleteAttr>,
      default: 'email',
    },

    /**
     * フォームのフォーカスアウト時に前後ホワイトスペースの trim するかどうか
     */
    hasTrim: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['update:modelValue', 'error'],

  setup(props, { emit }) {
    // store
    const userStore = useUserStore()

    const localValue = ref('')

    const computedHeader = computed((): string => {
      return props.header || '勤務先メールアドレス'
    })

    watch(() => props.modelValue, () => {
      localValue.value = props.modelValue
    })

    onMounted(() => {
      localValue.value = props.modelValue
    })

    /**
     * store に格納されている、アカウントの登録メールアドレスで入力を補完
     *
     * @description store 情報をこのコンポーネントから emit で親に伝えることにより、
     *              親側で state の書き換わりが起こり、それが modelValue で渡されているこのコンポーネントにも伝わる。
     *              そして、その modelValue の変更によりこのコンポーネントの watcher が反応することで、
     *              コンポーネント内の localValue も書き換わる仕組み
     */
    const autoCompleteMailAddress = () => {
      emit('update:modelValue', userStore.context.mailaddress)
    }

    return {
      // store
      userStore,

      // data
      localValue,

      // computed
      computedHeader,

      // methods
      autoCompleteMailAddress,
    }
  }
})
</script>

<template>
  <InputFormMailAddress
    :model-value="localValue"
    :namespace="namespace"
    :name="name"
    :header="computedHeader"
    :has-trim="hasTrim"
    :validation-scheme="validationScheme"
    @update:model-value="$emit('update:modelValue', $event)">
    <p class="p u-margin__smaller u-text__x-small">
      <button
        class="button"
        @click.prevent="autoCompleteMailAddress">
        {{ userStore.context.mailaddress }}を使用する
      </button>
    </p>
  </InputFormMailAddress>
</template>

